import { render, staticRenderFns } from "./TimeStatistic.vue?vue&type=template&id=6babbd0d&"
import script from "./TimeStatistic.vue?vue&type=script&lang=js&"
export * from "./TimeStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports